import { render, staticRenderFns } from "./choosenCard.vue?vue&type=template&id=6d0df2db"
import script from "./choosenCard.vue?vue&type=script&lang=js"
export * from "./choosenCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports